import {useMutation} from "@tanstack/react-query";

import {restoreServiceMutationOptions} from "./restore-service.mutation-options";

export function useRestoreService() {
  return useMutation(restoreServiceMutationOptions());
}
